import { render, staticRenderFns } from "./DatosCompanyForm.vue?vue&type=template&id=0667585c"
import script from "./DatosCompanyForm.vue?vue&type=script&lang=js"
export * from "./DatosCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports